import { useEffect, useState } from "react"

import { ContentObjectStatus } from "@vertesia/common"

import { useUserSession } from "@session/UserSession"

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

const INTERVAL_TIMER = 10000

interface UploadStatusProps {
    documentId: string
}
export function UploadStatus({ documentId }: UploadStatusProps) {
    const { client } = useUserSession()
    const [status, setStatus] = useState("")
    const [color, setColor] = useState("grey")
    const [blinking, setBlinking] = useState(false)

    const retrieveDocumentStatus = () => {
        if (!client || !documentId) {
            return
        }

        let id = documentId
        if (documentId.startsWith("store:")) {
            id = documentId.split(":").pop() || ""
        }

        client.objects.retrieve(id).then((doc) => {
            const completed = doc.status === ContentObjectStatus.completed
            setStatus(doc.status)
            setColor(completed ? "green" : "orange")
            setBlinking(!completed)

            if (!completed) {
                setTimeout(retrieveDocumentStatus, INTERVAL_TIMER)
            }
        })
    }

    useEffect(() => {
        retrieveDocumentStatus()
    }, [documentId, client])

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger className="text-primary">
                    <span className={`w-[10px] h-[10px] rounded-full inline-block ${blinking ? "animate-pulse" : ""}`} style={{ backgroundColor: color }} />
                </TooltipTrigger>
                <TooltipContent>
                    <p>{status}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}
